"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var util_1 = require("./util");
var defaultOptions = {
    elementDelimiter: '__',
    modDelimiter: '_',
    modValueDelimiter: '_',
    transformKeys: function (str) { return str; }
};
var isValidClassName = /^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/;
function block(name, options) {
    if (options === void 0) { options = {}; }
    var opts = util_1.assign({}, defaultOptions, options);
    function bem() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var base = name;
        var mods = {};
        var mix = [];
        if (arguments.length > 0) {
            var el = args[0], rest = args.slice(1);
            if (typeof el === 'string') {
                base += opts.elementDelimiter + el;
                _a = parseArgs(rest), mods = _a[0], mix = _a[1];
            }
            else {
                _b = parseArgs([el].concat(rest)), mods = _b[0], mix = _b[1];
            }
        }
        return toClassName({ base: base, mods: mods, mix: mix }, opts);
        var _a, _b;
    }
    ;
    return bem;
}
exports.default = block;
function parseArgs(args) {
    var mods = {};
    var mix = [];
    args.forEach(function (x) {
        if (x instanceof react_1.Component) {
            util_1.assign(mods, pickMods(x.props || {}));
            util_1.assign(mods, pickMods(x.state || {}));
            return;
        }
        if (Array.isArray(x)) {
            [].push.apply(mix, x);
            return;
        }
        util_1.assign(mods, pickMods(x));
    });
    return [mods, mix];
}
/**
 * Pick key-value pairs which make valid BEM modifiers
 * @param target Object containing modifiers
 */
function pickMods(target) {
    return util_1.pickBy(target, function (v, k) {
        // Modifier value is boolean and is `true`
        return v === true ||
            // Modifier value is an integer
            typeof v === 'number' && Math.floor(v) === v ||
            // Modifier value is a string and makes a valid class name with its name
            typeof v === 'string' && isValidClassName.test(k + v);
    });
}
/**
 * Turn all parsed options into a class name
 * @param source Arguments parsed before
 * @param opts Propmods options
 */
function toClassName(source, opts) {
    var base = source.base, mods = source.mods, mix = source.mix;
    var modClasses = Object.keys(mods).map(function (key) {
        var name = opts.transformKeys(key);
        var value = mods[key];
        var mod = typeof value === 'boolean' ?
            name :
            name + opts.modValueDelimiter + value.toString();
        return base + opts.modDelimiter + mod;
    });
    return {
        className: [base].concat(modClasses, mix).join(' ')
    };
}
